export default __webpack_public_path__ + "22da5a20ab7d8bf269cff471eefd38fc.svg";